export function elementsIntoPages(
  elements: unknown[] | undefined,
  pageSize: number
): unknown[][] {
  if (!elements) {
    return [];
  }
  return Array.from(
    { length: Math.ceil(elements.length / pageSize) },
    (skip, index) =>
      elements.slice(index * pageSize, index * pageSize + pageSize)
  );
}
